import { Parser } from 'htmlparser2';
import { isFeatureEnabled } from '../../../../services/Features';
import { getGlossary } from '../../../../services/Glossary';
import { createMountPoint, replaceMountPoint } from '../../helper';
import GlossaryTermHighlight from './GlossaryTermHighlight';

export const name = 'glossary';
export const defaultProp = true;

const RTE_GLOSSARY_TERM = 'rte-glossary-term';

function escapeRegExp(str) {
    return str.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}

// TODO consolidate this with the "highlight" plugin in ../highlight/index.js. See:
// - https://linear.app/small-improvements/issue/DEV-186/refactor-duplicated-richtext-features
class Handler {
    constructor(appendFn, keywords) {
        this._append = appendFn;
        this._regex = new RegExp(
            `\\b(${keywords
                .slice()
                .sort((a, b) => b.length - a.length)
                .map(escapeRegExp)
                .join('|')})\\b`,
            'gi'
        );
    }

    onopentag(tag, attrs) {
        this._append('<' + tag);
        for (const attr in attrs) {
            if (Object.prototype.hasOwnProperty.call(attrs, attr)) {
                this._append(` ${attr}="${attrs[attr]}"`);
            }
        }
        this._append('>');
    }

    onclosetag(tag) {
        this._append('</' + tag + '>');
    }

    ontext(text) {
        this._append(this.replace(text));
    }

    replace(str) {
        const out = str.replace(this._regex, matched =>
            createMountPoint(RTE_GLOSSARY_TERM, { keyword: matched }, matched)
        );
        this._regex.lastIndex = 0;
        return out;
    }
}

export function onParse(content, enabled) {
    if (!enabled || !isFeatureEnabled('FEATURE_glossary')) {
        return content;
    }
    const keywords = getGlossary().map(term => term.keyword);
    if (!keywords.length) {
        return content;
    }

    let result = '';
    const parser = new Parser(new Handler(s => (result += s), keywords), { decodeEntities: false });
    parser.write(content);
    parser.end();
    return result;
}

export function onMount(node) {
    if (!isFeatureEnabled('FEATURE_glossary')) {
        return undefined;
    }
    return replaceMountPoint(node, RTE_GLOSSARY_TERM, data => <GlossaryTermHighlight keyword={data.keyword} />);
}
